import React, { useEffect, useState } from 'react'
import { useIndexedDB } from '../../../context/IndexedContext'
import GraytextareaAdjustable from '../../../components/GrayTextareaAdjustable'

const DifferentialDiagnosisRecords = ({ patientDBdata, isSavingTheData, patientID, loggedUserProvider, diagnosisName, setPatientDBdata, noteID }) => {
    

    const [textValue, setTextValue] = useState("")
    const [modalText, setModalText] = useState("")

    useEffect(() => {
        const differnetialTtext = patientDBdata?.currentNote?.data?.patientDifferentialDiagnosis?.[diagnosisName] || ""
        
        setModalText(differnetialTtext)
        setTextValue(differnetialTtext)
    }, [])


    const handleBlur = () => {
        setPatientDBdata((prev) => {
            return {
                ...prev,
                currentNote: {
                    ...prev?.currentNote,
                    data: {
                        ...prev?.currentNote?.data,
                        patientDifferentialDiagnosis: {
                            ...prev?.currentNote?.data?.patientDifferentialDiagnosis,
                            [diagnosisName]: modalText,
                        },
                    },
                },
                allNotes: prev?.allNotes?.map((note) => {
                    if (note?.id === noteID) {
                        const parsedData = note?.data ? JSON.parse(note.data) : {}
                        return {
                            ...note,
                            data: JSON.stringify({
                                ...parsedData,
                                patientDifferentialDiagnosis: {
                                    ...parsedData?.patientDifferentialDiagnosis,
                                    [diagnosisName]: modalText,
                                },
                            }),
                        }
                    }
                    return note
                }),
            }
        })
    }

    if (!textValue) {
        return
    }

    return (
        <div className='w-100'>
            <div>Differential Diagnosis</div>
            <div className='d-flex flex-column gap-3 w-100'>
                <GraytextareaAdjustable
                    onBlur={handleBlur}
                    onChange={(e) => {
                        setModalText(e.target.value)
                    }}
                    height={"100px"}
                    value={modalText}
                />
            </div>
        </div>
    )
}

export default DifferentialDiagnosisRecords